import React from 'react';
import SubmitClaimWizard from './SubmitClaimWizard';

const JoinNotice = () => {
  return <SubmitClaimWizard initialStep={1} />;
};

export default JoinNotice;